import React from 'react'

export const TemplateBlockTwelve = ({ templateBlockClick, activeBlock }) => {
  return (
    <div className='flex flex-col w-full text-center'>

      <div className={`w-full p-4 bg-gray-200 rounded-lg flex flex-col gap-4 min-h-[270px] ${activeBlock === 12 ? "border-red-500 border-2" : ""}`}
        onClick={() => templateBlockClick(12,5)}
      >
        <div className="w-full flex justify-evenly gap-4 h-full">
          <div className='w-1/3 flex flex-col h-full gap-4'>
            <div className="h-full border-2 border-blue-500"></div>
            <div className="h-full border-2 border-blue-500"></div>
          </div>
          <div className='w-1/3 h-full'>
            <div className="h-full border-2 border-blue-500"></div>
          </div>
          <div className='w-1/3 flex flex-col h-full gap-4'>
            <div className="h-full border-2 border-blue-500"></div>
            <div className="h-full border-2 border-blue-500"></div>
          </div>
        </div>
        {/* <div className="w-full flex justify-evenly gap-4">
            <div className="w-1/4 h-32 border-2 border-blue-500"></div>
            <div className="w-1/4 h-32 border-2 border-blue-500"></div>
            <div className="w-2/4 h-32 border-2 border-blue-500"></div>
          </div> */}
      </div>
      <p className='font-bold'>Type 13</p>
    </div>
  )
}
